import { useAxiosApi } from './useAxiosApi'

const stripPrefix = (index) => index.replace(/^engine_/, '')

/**
 * Normalize Typesense document: cast `id` back to number when possible,
 * so downstream consumers don't break on string vs number comparisons.
 */
const normalizeDoc = (doc) => {
    const id = doc.id != null && !isNaN(doc.id) ? Number(doc.id) : doc.id
    return { ...doc, id }
}

export default function useSearch() {
    const { requestPost } = useAxiosApi()

    const multiSearch = async (query, indexes, hitsPerPage = 200) => {
        const res = await requestPost('/search', {
            query,
            indexes: indexes.map(stripPrefix),
            hitsPerPage,
        })
        return { results: res.data.results }
    }

    const singleSearch = async (index, query, { hitsPerPage = 200, filters } = {}) => {
        const res = await requestPost('/search/index', {
            query,
            index: stripPrefix(index),
            hitsPerPage,
            ...(filters && { filter: filters }),
        })
        const hits = (res.data.hits ?? []).map((hit) => {
            const doc = hit.document ?? {}
            const highlightResult = {}
            for (const h of hit.highlights ?? []) {
                highlightResult[h.field] = {
                    value: h.snippet ?? h.snippets?.[0] ?? h.value ?? '',
                }
            }
            return { ...normalizeDoc(doc), _highlightResult: highlightResult }
        })
        return { hits }
    }

    return { multiSearch, singleSearch, isReady: true }
}
